export class DropdownMenu {
  Name: string;
  Route: string;
  PageNum: number;
  Completed: boolean;

  constructor(name: string, route: string, pageNum: number) {
    this.Name = name;
    this.Route = route;
    this.PageNum = pageNum;
    this.Completed = false;
  }
}
